import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "card-header-row"
};
const _hoisted_2 = {
  class: "header-left"
};
const _hoisted_3 = {
  class: "header-title-row"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "card-status"
};
const _hoisted_6 = ["aria-label", "aria-expanded"];
const _hoisted_7 = {
  class: "report-section score-section"
};
const _hoisted_8 = {
  class: "report-section-heading"
};
const _hoisted_9 = {
  class: "heading-text"
};
const _hoisted_10 = {
  class: "score-stage"
};
const _hoisted_11 = {
  class: "score-summary-card"
};
const _hoisted_12 = {
  class: "score-block"
};
const _hoisted_13 = {
  class: "score-num"
};
const _hoisted_14 = {
  class: "grade-block"
};
const _hoisted_15 = {
  key: 1,
  class: "grade-badge tone-pending"
};
import { ref, onMounted, onUnmounted, computed, watch } from 'vue';
import useMainStore, { storeToRefs } from '@views/main/main.store';
import { setFoldFunc, removeFoldFunc } from '@views/main/states/fold.state';
import initIncrementalUpdate from '../report-items/mixins/incrementalUpdate.mixin';
import sparklesIcon from './geo-analysis-sparkles.png';
const title = '报告计算与生成';
export default /*@__PURE__*/_defineComponent({
  __name: 'GeoReportGen',
  props: {
    item: {},
    content: {}
  },
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const mainStore = useMainStore();
    const {
      incrementalMessageList
    } = storeToRefs(mainStore);
    const info = ref({});
    const subNodes = ref([]);
    const isFold = ref(false);
    const EXPECTED_SUB_CODES = [60401, 60402];
    let nextLoaded = false;
    const doneCount = computed(() => subNodes.value.filter(n => n.status === 3).length);
    const total = computed(() => subNodes.value.length);
    const isAllDone = computed(() => total.value > 0 && doneCount.value === total.value);
    const titleSuffix = computed(() => {
      if (info.value.executeStatus === 3) return `(已完成 ${total.value}/${total.value})`;
      if (info.value.executeStatus === 2) return '(失败)';
      if (total.value === 0) return '';
      if (isAllDone.value) return `(已完成 ${doneCount.value}/${total.value})`;
      return `(进行中 ${doneCount.value}/${total.value})`;
    });
    const scoreNode = computed(() => subNodes.value.find(n => {
      const d = n.data || {};
      return d.geo_score !== undefined || d.overall_score !== undefined || d.score !== undefined || d.grade !== undefined || d.level !== undefined;
    }));
    const scoreValue = computed(() => {
      const d = scoreNode.value?.data || {};
      const v = d.geo_score ?? d.overall_score ?? d.score;
      if (v === undefined || v === null) return null;
      const n = Number(v);
      return Number.isNaN(n) ? null : n;
    });
    const scoreLabel = computed(() => {
      const d = scoreNode.value?.data || {};
      if (d.geo_score !== undefined) return 'GEO评分';
      if (d.overall_score !== undefined) return '综合评分';
      return '评分';
    });
    const gradeInfo = computed(() => {
      const d = scoreNode.value?.data || {};
      const raw = d.grade || d.level;
      if (raw) {
        const text = String(raw);
        let tone = 'ok';
        if (/优|good|excellent|a\b/i.test(text)) tone = 'good';else if (/差|低|poor|bad|d\b|e\b/i.test(text)) tone = 'bad';
        return {
          text,
          tone
        };
      }
      if (scoreValue.value === null) return null;
      if (scoreValue.value >= 80) return {
        text: '优秀',
        tone: 'good'
      };
      if (scoreValue.value >= 60) return {
        text: '一般',
        tone: 'ok'
      };
      return {
        text: '较差',
        tone: 'bad'
      };
    });
    const scoreSectionSubtitle = computed(() => {
      if (!scoreNode.value) return '正在汇总评分结果与问题优先级';
      if (scoreNode.value.status === 1) return '正在计算评分中...';
      return '已完成评分汇总';
    });
    const toggleFold = val => {
      isFold.value = typeof val === 'boolean' ? val : !isFold.value;
    };
    const tryLoadNext = () => {
      if (nextLoaded || !props.item?.openAnimate) return;
      const allArrived = EXPECTED_SUB_CODES.every(code => subNodes.value.some(n => n.code === code));
      const noneRunning = subNodes.value.every(n => n.status !== 1);
      const stageFinished = info.value.executeStatus === 3 || info.value.executeStatus === 2;
      if (stageFinished || allArrived && noneRunning && subNodes.value.length > 0) {
        nextLoaded = true;
        mainStore.loadNextMsg(props.item);
      }
    };
    const {
      handleIncrementalMessage
    } = initIncrementalUpdate(async message => {
      if (props.item.id === message.id) {
        const {
          incrementalData,
          messageType,
          openAnimate
        } = message;
        const nodeName = message.nodeName || `节点${messageType}`;
        isFold.value = false;
        if (incrementalData.error) {
          const existing = subNodes.value.find(n => n.code === messageType);
          if (existing) {
            existing.status = 2;
            existing.data = {
              error: incrementalData.error
            };
          } else {
            subNodes.value.push({
              code: messageType,
              nodeName,
              status: 2,
              data: {
                error: incrementalData.error
              }
            });
          }
        } else {
          const existing = subNodes.value.find(n => n.code === messageType);
          const newStatus = openAnimate === 1 ? 1 : 3;
          if (existing) {
            existing.status = newStatus;
            existing.data = incrementalData;
          } else {
            subNodes.value.push({
              code: messageType,
              nodeName,
              status: newStatus,
              data: incrementalData
            });
          }
        }
        tryLoadNext();
      }
    });
    const initFromMessageContent = () => {
      const {
        messageContent
      } = info.value;
      if (!messageContent) return;
      Object.entries(messageContent).forEach(([code, nodeData]) => {
        const existing = subNodes.value.find(n => n.code === Number(code));
        if (existing) {
          existing.status = nodeData.status;
          existing.data = nodeData;
        } else {
          subNodes.value.push({
            code: Number(code),
            nodeName: nodeData.nodeName || `节点${code}`,
            status: nodeData.status,
            data: nodeData
          });
        }
      });
    };
    onUnmounted(() => {
      mainStore.componentFunMap.delete(props.item.id);
      if (props.item.id) removeFoldFunc(props.item.id);
    });
    watch(() => props.content, val => {
      if (!val) return;
      info.value = val;
      initFromMessageContent();
      tryLoadNext();
    });
    onMounted(() => {
      if (props.item.id) {
        mainStore.componentFunMap.set(props.item.id, handleIncrementalMessage);
        setFoldFunc(props.item.id, toggleFold);
      }
      try {
        info.value = props.content || {};
        initFromMessageContent();
        if (props.item.incrementalIds) {
          props.item.incrementalIds.forEach(id => {
            handleIncrementalMessage(incrementalMessageList.value[id]);
          });
        }
        tryLoadNext();
      } catch (e) {
        info.value = {};
      }
    });
    __expose({
      isFold,
      setIsFold: val => {
        isFold.value = val;
      }
    });
    return (_ctx, _cache) => {
      const _component_i_home_down = _resolveComponent("i-home-down");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("article", {
        class: _normalizeClass(["process-card report-generation-card", {
          'is-collapsed': isFold.value,
          'is-all-done': isAllDone.value
        }])
      }, [_cache[10] || (_cache[10] = _createElementVNode("svg", {
        class: "geo-rep-svg-sprite",
        "aria-hidden": "true",
        focusable: "false"
      }, [_createElementVNode("defs", null, [_createElementVNode("linearGradient", {
        id: "geo-rep-grad-purple",
        x1: "0",
        y1: "0",
        x2: "24",
        y2: "24",
        gradientUnits: "userSpaceOnUse"
      }, [_createElementVNode("stop", {
        "stop-color": "#8d86ff"
      }), _createElementVNode("stop", {
        offset: "1",
        "stop-color": "#5b63f4"
      })])]), _createElementVNode("symbol", {
        id: "geo-rep-icon-score-pie",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        cx: "12",
        cy: "12",
        r: "9",
        fill: "url(#geo-rep-grad-purple)"
      }), _createElementVNode("path", {
        d: "M12 4.2a7.8 7.8 0 0 1 7.8 7.8H12V4.2Z",
        fill: "#fff",
        opacity: ".9"
      }), _createElementVNode("path", {
        d: "M12 12h7.8a7.8 7.8 0 0 1-4.5 7.1L12 12Z",
        fill: "#fff",
        opacity: ".45"
      })]), _createElementVNode("symbol", {
        id: "geo-rep-icon-list",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("rect", {
        x: "5",
        y: "3.8",
        width: "14",
        height: "16.4",
        rx: "2.2",
        fill: "url(#geo-rep-grad-purple)"
      }), _createElementVNode("path", {
        d: "M9 8h6M9 12h6M9 16h4.5",
        stroke: "#fff",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        opacity: ".92"
      })]), _createElementVNode("symbol", {
        id: "geo-rep-icon-sparkles",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        d: "M8 2.4 9.7 7l4.6 1.7-4.6 1.7L8 15l-1.7-4.6-4.6-1.7L6.3 7 8 2.4Z",
        fill: "url(#geo-rep-grad-purple)"
      }), _createElementVNode("path", {
        d: "m17.1 3.5.9 2.4 2.4.9-2.4.9-.9 2.4-.9-2.4-2.4-.9 2.4-.9.9-2.4ZM17.8 14.1l1.2 3.1 3.1 1.2-3.1 1.2-1.2 3.1-1.2-3.1-3.1-1.2 3.1-1.2 1.2-3.1Z",
        fill: "#6d65ff",
        opacity: ".75"
      })]), _createElementVNode("symbol", {
        id: "geo-rep-icon-warning",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        d: "M12 4.4 21 19H3L12 4.4Z",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linejoin": "round"
      }), _createElementVNode("path", {
        d: "M12 9.2v5",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2.2",
        "stroke-linecap": "round"
      }), _createElementVNode("circle", {
        cx: "12",
        cy: "17.2",
        r: "1.1",
        fill: "currentColor"
      })])], -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        class: "card-sparkles-img",
        src: _unref(sparklesIcon),
        alt: ""
      }, null, 8, _hoisted_4), _createElementVNode("span", {
        class: "card-title truncat"
      }, _toDisplayString(title)), _createElementVNode("span", _hoisted_5, _toDisplayString(titleSuffix.value), 1)])]), _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["collapse-button", {
          'is-fold': isFold.value
        }]),
        "aria-label": isFold.value ? '展开' : '收起',
        "aria-expanded": !isFold.value,
        onClick: _cache[0] || (_cache[0] = $event => toggleFold())
      }, [_createVNode(_component_el_icon, {
        class: "collapse-icon",
        color: "#4E5969"
      }, {
        default: _withCtx(() => [_createVNode(_component_i_home_down)]),
        _: 1
      })], 10, _hoisted_6)]), _createElementVNode("section", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "report-section-icon score-icon"
      }, [_createElementVNode("svg", {
        "aria-hidden": "true"
      }, [_createElementVNode("use", {
        href: "#geo-rep-icon-score-pie"
      })])], -1)), _createElementVNode("div", _hoisted_9, [_cache[1] || (_cache[1] = _createElementVNode("h3", null, "分数聚合与评级", -1)), _createElementVNode("p", null, _toDisplayString(scoreSectionSubtitle.value), 1)]), _cache[3] || (_cache[3] = _createElementVNode("svg", {
        class: "section-sparkles",
        "aria-hidden": "true"
      }, [_createElementVNode("use", {
        href: "#geo-rep-icon-sparkles"
      })], -1))]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString(scoreLabel.value), 1), _createElementVNode("div", _hoisted_13, [_createElementVNode("strong", null, _toDisplayString(scoreValue.value !== null ? scoreValue.value : '--'), 1), _cache[4] || (_cache[4] = _createElementVNode("em", null, "/100", -1))])]), _cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "score-divider"
      }, null, -1)), _createElementVNode("div", _hoisted_14, [_cache[6] || (_cache[6] = _createElementVNode("span", null, "等级", -1)), gradeInfo.value ? (_openBlock(), _createElementBlock("b", {
        key: 0,
        class: _normalizeClass(["grade-badge", `tone-${gradeInfo.value.tone}`])
      }, [_createTextVNode(_toDisplayString(gradeInfo.value.text) + " ", 1), _cache[5] || (_cache[5] = _createElementVNode("svg", {
        "aria-hidden": "true"
      }, [_createElementVNode("use", {
        href: "#geo-rep-icon-warning"
      })], -1))], 2)) : (_openBlock(), _createElementBlock("b", _hoisted_15, "--"))]), _cache[8] || (_cache[8] = _createElementVNode("p", null, "分数越高代表站点在生成式引擎（如AI Overview / ChatGPT）中的可见性与被引用潜力越强", -1))]), _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"score-visual\" aria-hidden=\"true\" data-v-200694a8><span class=\"visual-orbit\" data-v-200694a8></span><span class=\"visual-platform\" data-v-200694a8></span><span class=\"visual-bar bar-one\" data-v-200694a8></span><span class=\"visual-bar bar-two\" data-v-200694a8></span><span class=\"visual-bar bar-three\" data-v-200694a8></span><svg class=\"visual-sparkle sparkle-one\" data-v-200694a8><use href=\"#geo-rep-icon-sparkles\" data-v-200694a8></use></svg><svg class=\"visual-sparkle sparkle-two\" data-v-200694a8><use href=\"#geo-rep-icon-sparkles\" data-v-200694a8></use></svg></div>", 1))])])], 2);
    };
  }
});